module.exports = __webpack_public_path__ + "static/media/logo.d07f1015.png";